<app-page-header>
  <!-- Template ref needed for content child directive -->
  <ng-template #headerBarControlsTemplate>
    @if (timeEntriesListViewService.trackerActive() === null) {
      <!-- Waiting for websocket check-->
      <div class="k-ml-2" style="white-space: nowrap">Waiting for tracker...</div>
    } @else {
      <kendo-splitbutton
        themeColor="secondary"
        size="large"
        [data]="timeEntriesListViewService.startTimerButton()"
        (buttonClick)="timeEntriesListViewService.openDialog()"
      >
        <span class="custom-symbol add turquoise k-mr-3"></span>
        <span>Neuer Zeiteintrag</span>

        <ng-template kendoSplitButtonItemTemplate let-item>
          <fa-icon class="k-mr-2 turquoise" [icon]="faPlay" size="lg"></fa-icon>
          {{ item.text }}
        </ng-template>
      </kendo-splitbutton>
    }
  </ng-template>
</app-page-header>

<div class="card-wrapper">
  <div class="card">
    <div class="card-body">
      <button kendoButton (click)="setAggregateMode(TimeUnits.None)">Alle</button>
      <button kendoButton (click)="setAggregateMode(TimeUnits.Day)">Pro Tag</button>
      <button kendoButton (click)="setAggregateMode(TimeUnits.Month)">Pro Monat</button>

      <div id="time-entries-table-wrapper" class="k-w-full">
        <app-shive-grid #gridWrapperComponent [grid]="grid">
          <kendo-grid
            #grid
            kendoGridSelectBy="id"
            scrollable="none"
            size="medium"
            [kendoGridBinding]="(gridData$ | async) ?? []"
            [pageSize]="100"
            [selectable]="{ enabled: true, checkboxOnly: true }"
            [columnMenu]="{ filter: true }"
            [groupable]="true"
            [group]="group"
            kendoGridExpandGroupBy
            [isRowSelectable]="timeEntriesListViewService.isRowSelectable"
            [groupsInitiallyExpanded]="false"
            [expandedGroupKeys]="[]"
            [(selectedKeys)]="selectedKeys"
          >
            <ng-template kendoGridToolbarTemplate>
              <div class="k-d-inline-flex k-align-items-baseline">
                <h3 class="headline k-m-0 k-font-weight-semibold">Zeiteinträge</h3>
              </div>

              <div class="k-ml-auto k-mr-15">
                @if (selectedKeys.length > 0) {
                  <span
                    class="icon-button k-mr-8"
                    (click)="timeEntriesListViewHttpService.deleteMultipleTimeBlocks(selectedKeys)"
                  >
                    <fa-icon
                      class="icon red turquoise k-mr-1.5"
                      size="sm"
                      [icon]="faTrash"
                    ></fa-icon>
                    <span>({{ selectedKeys.length }}) Zeiteinträge Löschen</span>
                  </span>
                }

                <span class="icon-button k-mr-8">
                  <fa-icon class="icon turquoise k-mr-1.5" size="sm" [icon]="faFilter"></fa-icon>
                  <span>Filter</span>
                </span>

                <span class="icon-button">
                  <fa-icon
                    class="icon turquoise k-mr-1.5"
                    size="sm"
                    [icon]="faObjectGroup"
                  ></fa-icon>
                  <span>Group</span>
                </span>
              </div>
            </ng-template>
            <kendo-grid-checkbox-column
              [width]="60"
              [headerClass]="{ 'k-text-center': true }"
              [resizable]="false"
              [columnMenu]="false"
              [showSelectAll]="true"
            >
              <!-- Header: "check all" -->
              <ng-template kendoGridHeaderTemplate>
                <input type="checkbox" kendoCheckBox kendoGridSelectAllCheckbox />
              </ng-template>

              <!-- Cells: row checkbox -->
              <ng-template kendoGridCellTemplate let-row let-rowIndex="rowIndex">
                <span class="k-cell-inner">
                  <span class="k-link !k-cursor-default">
                    @if (!row.isActive) {
                      <input
                        type="checkbox"
                        kendoCheckBox
                        [kendoGridSelectionCheckbox]="rowIndex"
                      />
                    }
                  </span>
                </span>
              </ng-template>
            </kendo-grid-checkbox-column>

            <kendo-grid-column field="date" title="Datum">
              <ng-template kendoGridGroupHeaderColumnTemplate let-group="group">
                {{ group.value | date: "dd.MM.yyyy" }}
              </ng-template>

              <ng-template kendoGridCellTemplate let-row>
                {{ row.from | date: "dd.MM.yyyy" }}
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="projectOrAbsence" title="Projekt / Abwesenheit">
              <ng-template kendoGridCellTemplate let-row>
                {{ row.project ?? row.reason }}
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="task" title="Aufgabe"> </kendo-grid-column>

            <kendo-grid-column field="description" title="Beschreibung"> </kendo-grid-column>

            <kendo-grid-column field="from" title="Von">
              <ng-template kendoGridCellTemplate let-row>
                {{ row.from | date: "HH:mm" }}
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="to" title="Bis">
              <ng-template kendoGridCellTemplate let-row>
                {{ row.to | date: "HH:mm" }}
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="workingTime" title="Arbeitszeit">
              <ng-template kendoGridGroupHeaderColumnTemplate let-aggregates="aggregates">
                Total:
                {{
                  aggregates.workingTime.sum | timeFormat: TimeFormatType.SecondsToHoursAndMinutes
                }}
              </ng-template>

              <ng-template kendoGridCellTemplate let-row>
                {{ row.workingTime | timeFormat: TimeFormatType.SecondsToHoursAndMinutes }}
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="contextMenu" title="" [columnMenu]="false" [width]="60">
              <ng-template kendoGridCellTemplate let-dataItem>
                <app-context-menu-anchor
                  [dataItem]="dataItem"
                  [gridWrapperComponent]="gridWrapperComponent"
                />
              </ng-template>
            </kendo-grid-column>
          </kendo-grid>
        </app-shive-grid>
      </div>
    </div>
  </div>
</div>
